var Immutable = require('immutable');
var { guid } = require('../../../../../libraries/utils/guid');
var { TEXT } = require('./types');

var TextEntityFields = Immutable.Record({
  id: guid(),
  type: TEXT,
  text: ''
});

class TextEntity extends TextEntityFields {
  parse(data) {
    if (!data) {
      return this;
    }

    var fields = {};

    ['id', 'text', 'type'].forEach(
      field => (fields[field] = data[field] !== undefined ? data[field] : this.get(field))
    );

    var newTextEntity = new TextEntity(fields);
    return Immutable.is(this, newTextEntity) ? this : newTextEntity;
  }
  isEmpty() {
    var text = this.get('text');
    return !text || !text.trim();
  }
  toJSON() {
    return {
      id: this.get('id'),
      type: this.get('type'),
      text: this.get('text')
    };
  }
  static fromJSON(json) {
    return new TextEntity().parse(json);
  }
}

export default TextEntity;
